import { render, staticRenderFns } from "./template.html?vue&type=template&id=392cf41c&scoped=true&"
import script from "./HomeHistoryEn.vue?vue&type=script&lang=ts&"
export * from "./HomeHistoryEn.vue?vue&type=script&lang=ts&"
import style0 from "./HomeHistoryEn.vue?vue&type=style&index=0&id=392cf41c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392cf41c",
  null
  
)

export default component.exports